import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import FavoriteIcon from "@material-ui/icons/Favorite";
import NoteIcon from '@material-ui/icons/Note';
import { connect } from "react-redux";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { mensaje } from "../../redux/aciones/mensajes";
import image from '../../recursos/logo192.jpg'
import Swal from 'sweetalert2'

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 345,
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    margin: theme.spacing(4),
    flexGrow: 1
  },
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  avatar: {
    backgroundColor: red[500]
  }
}));

const CardVacante = ({
  vacante_item_elemento,
  mandarSolicitudPostulante,
  auth,
  pdf,
  mensaje
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const {
    empresa,
    contrato,
    descripcion,
    vacante,
    ubicacion,
    id
  } = vacante_item_elemento;
  const description = descripcion.slice(0, 100);

  const EnviaraDatosPostulante = () => {
    
    if (pdf!=='') {
      const { uid, email, usuario } = auth;
      const data = {
        id,
        uid,
        email,
        usuario,
        pdf
      };
      Swal.fire({
        title: 'Esta Seguro?',
        text: "Que desea postularse a esta vacante !",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, comfirmar!',
        cancelButtonText:'Cancelar'
        
        
      }).then((result) => {
        if (result.value) {
          Swal.fire(
            'Se Registrado!',
            'Su hoja de vida ha sido enviado correctamente .',
            'success'
          )
          mandarSolicitudPostulante(data);
        }
      })
      
    }
   else{
    mensaje("Aun no ingresado su Hoja de vida  ", "warning");
   }
  };

  return (
    <Card className={classes.card} key={id}>
      <CardHeader
        avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            <NoteIcon/>
          </Avatar>
        }
        title={vacante.toUpperCase()}
        subheader={empresa.toUpperCase()}
      />
      <CardMedia
        className={classes.media}
        image={image}
        title="Paella dish"
      />
      <CardContent>
        <Typography variant="body2" color="textSecondary" component="p">
          {description}
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton
          aria-label="add to favorites"
          onClick={EnviaraDatosPostulante}
        >
          <FavoriteIcon />

        </IconButton>
        <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>Empresa:{empresa}</Typography>
          <Typography paragraph>Ubicacion:{ubicacion}</Typography>
          <Typography paragraph>Tipo Contrato:{contrato}</Typography>
          <Typography paragraph>Tipo Vacante:{vacante}</Typography>
          <Typography paragraph>Descripcion:{descripcion}</Typography>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default connect(null, { mensaje })(CardVacante);
